import { render, staticRenderFns } from "./ModalDocumentRenderFund.vue?vue&type=template&id=d484ab4c&scoped=true"
import script from "./ModalDocumentRenderFund.vue?vue&type=script&lang=js"
export * from "./ModalDocumentRenderFund.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentRenderFund.vue?vue&type=style&index=0&id=d484ab4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484ab4c",
  null
  
)

export default component.exports